import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { TableHead, TableRow, TableCell, makeStyles } from '@material-ui/core'
import statsTableStyles from './statsTable.styles'

const useStyles = makeStyles(statsTableStyles)

// Two-row header:
//   Row 1: group labels only (empty cell for ungrouped columns).
//   Row 2: every leaf label.
// `leftHeader` spans both rows in the first column(s).
// A thin vertical divider is drawn at every group boundary (all rows after the first).
const StatsTableHeader = ({ groups, leftHeader, leftColSpan = 1 }) => {
  const classes = useStyles()
  const leaves = groups.flatMap((g, gi) =>
    g.children.map((child, ci) => ({
      ...child,
      firstOfGroup: ci === 0 && gi > 0,
    })),
  )

  return (
    <TableHead>
      <TableRow className={classes.groupHeaderRow}>
        <TableCell
          rowSpan={2}
          colSpan={leftColSpan}
          className={classes.leftHeaderCell}
        >
          {leftHeader}
        </TableCell>
        {groups.map((group, idx) => (
          <TableCell
            key={`g-${idx}`}
            colSpan={group.children.length}
            className={classnames(
              group.label ? classes.groupHeaderCell : classes.groupHeaderEmptyCell,
              { [classes.categoryBorderLeft]: idx > 0 },
            )}
          >
            {group.label || ''}
          </TableCell>
        ))}
      </TableRow>
      <TableRow className={classes.leafHeaderRow}>
        {leaves.map(leaf => (
          <TableCell
            key={leaf.key}
            className={classnames(
              classes.leafHeaderCell,
              { [classes.categoryBorderLeft]: leaf.firstOfGroup },
            )}
          >
            {leaf.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

StatsTableHeader.propTypes = {
  groups: PropTypes.array.isRequired,
  leftHeader: PropTypes.node,
  leftColSpan: PropTypes.number,
}

export default StatsTableHeader
